<template>
  <div class="nav-box">
    <div class="logo-box" @click="returnHome()">
      <svg class="icon-svg return-icon" v-if="showReturn">
        <use xlink:href="#icon-last" />
      </svg>
      <img class="logo-icon" src="@/assets/images/nav/logo-icon.png" alt />
      <span>舟道教育科技</span>
    </div>
    <div class="user-box">
      <a-button class="login-button" type="primary" @click="loginIn" v-if="!user">登录</a-button>
      <div class="logined" v-if="user">
        <a-dropdown :trigger="['click']">
          <i class="avatar" :style="{ backgroundImage: 'url(' + user?.HeadPhotoPath + ')' }"></i>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="routerPath(`/personal`)">
                <span>个人中心</span>
              </a-menu-item>
              <a-menu-item @click="logout()">
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { PASSPORT_CLIENT_SERVER, LESSONPLAY_TOKEN, ONLINEURL, LOGINURL } from '@/config/url';

export default {
  name: "navroot",
  data() {
    return {
      user: null,
      showReturn: false,
    }
  },
  async mounted() {
    let user = this.$store.state.userInfo;
    if (user) this.user = user;

    //找到当前页
    this.$store.subscribe((res) => {
      if (!res) return;
      let { type, payload } = res;
      if (type == "showReturn") this.showReturn = payload;
    })
  },
  methods: {
    //退出
    logout() {
      this.$nzconfirm('确定要退出账号吗?', () => {
        let token = window.localStorage.getItem(LESSONPLAY_TOKEN);
        window.localStorage.removeItem(LESSONPLAY_TOKEN);
        location.href = `${PASSPORT_CLIENT_SERVER}/auth/logout?token=${token}&redirectURI=${location.href}&isTourist=true`;
      })
    },
    //跳转至个人中心
    routerPath(url) {
      this.$router.push(url);
      this.resetScroll();
    },
    //返回首页
    returnHome() {
      this.$router.push('/home');
      this.resetScroll();
    },
    //重置滚动条
    resetScroll() {
      this.showReturn = false;
      $('#content').animate({ scrollTop: 0 }, 300);
    },
    //跳转登录
    loginIn() {
      location.href = `${LOGINURL}?redirectURI=${location.href}`;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./nav.scss";
</style>